import $ from 'zepto';
import { registerRowItem } from '../forms';

export default class BaseField {
  /**
   * @param {Zepto} field
   */
  constructor(baseClasses) {
    this.onBlurField = this.onBlurField.bind(this);
    this.onFocusField = this.onFocusField.bind(this);
    Object.assign(this, baseClasses);
  }

  get value() {
    return this.$control.val();
  }

  /**
   * closes the field when it does not have value
   * and init the events
   *
   * @param {Zepto} field
   * @returns {BaseField}
   */
  initField(field, options = {}) {
    const { addEventHandlers = true } = options;
    this.$field = this.$field || $(field);
    this.$fieldGroup = this.$field.parent(`${this.fieldSelector}-group-2`);
    this.$control = this.$control || $(field).find(this.controlSelector);
    this.isInGroupField = this.$field.parent().hasClass(this.fieldGroup2Class);

    if (addEventHandlers) {
      this.$control
        .focus(this.onFocusField)
        .blur(this.onBlurField);
    }
    this.id = this.$control.get(0).id;

    this.$control.on('change', () => {
      if (!this.isEmpty()) {
        this.openField();
      }
    });

    if (this.$control.get(0) === document.activeElement) {
      this.focusField();
    } else {
      this.closeField();
    }

    registerRowItem({ field: this });

    return this;
  }

  isInsideOfFieldGroup() {
    return this.$fieldGroup.length === 1;
  }

  isInsideOfWideListFieldGroup() {
    return this.isInsideOfFieldGroup() && this.$fieldGroup.hasClass(`${this.fieldClass}-group-2--wide-list`);
  }

  hasErrorHighlight() {
    return (
      this.$fieldGroup.hasClass(`${this.fieldClass}-group-2--wide-list-error`)
      || this.$field.hasClass(`${this.fieldClass}--error`)
    );
  }

  // #region creators
  /**
   * creates an icon for the field and prepends it to the field
   *
   * @param {string} iconSrc
   * @returns {BaseField}
   */
  createFieldIcon(iconSrc) {
    $('<img/>', {
      class: this.iconClass,
      'area-hidden': true,
      src: iconSrc,
    })
      .prependTo(this.$field);

    return this;
  }
  // #endregion creators

  // #region actions
  addErrorHighlight() {
    if (this.isInsideOfWideListFieldGroup()) {
      this.$fieldGroup.addClass(`${this.fieldClass}-group-2--wide-list-error`);
    } else {
      this.$field.addClass(`${this.fieldClass}--error`);
    }

    return this;
  }

  removeErrorHighlight() {
    this.$fieldGroup.removeClass(`${this.fieldClass}-group-2--wide-list-error`);
    this.$field.removeClass(`${this.fieldClass}--error`);

    return this;
  }

  /**
   * gives the focus to the field
   *
   * @returns {BaseField}
   */
  focusField() {
    this.$field.addClass(this.focusFieldClass);
    return this;
  }

  /**
   * removes the focus to the field
   *
   * @returns {BaseField}
   */
  blurField() {
    this.$field.removeClass(this.focusFieldClass);
    return this;
  }

  /**
   * open the field
   *
   * @returns {BaseField}
   */
  openField() {
    this.$field.removeClass(this.closeFieldClass);
    return this;
  }

  /**
   * closes the field when it is empty
   *
   * @returns {BaseField}
   */
  closeField() {
    if (this.isEmpty()) {
      this.$field.addClass(this.closeFieldClass);
    }
    return this;
  }

  // #endregion actions

  // #region event handlers
  onFocusField() {
    this
      .openField()
      .focusField();

    return this;
  }

  onBlurField() {
    this
      .closeField()
      .blurField();

    return this;
  }
  // #endregion event handlers
}
